/* eslint-disable no-var */
/* eslint-disable no-param-reassign */
/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */
import store from '../store';

export default {
  install: (Vue) => {
    Vue.prototype.$dequeue = function dequeue() {
      if (Vue.prototype.$workingOnPromise) {
        return Promise.resolve();
      }
      if (Vue.prototype.$audio.length > 4) {
        Vue.prototype.$audio = [];
        return Promise.resolve();
      }
      const item = Vue.prototype.$audio.shift();
      if (!item) {
        return Promise.resolve();
      }
      try {
        Vue.prototype.$workingOnPromise = true;

        return new Promise(((resolve) => { // return a promise
          item.audio.addEventListener('ended', resolve);
          item.audio.play();
        })).then(() => {
          Vue.prototype.$workingOnPromise = false;
          Vue.prototype.$dequeue();
        });
      } catch (err) {
        Vue.prototype.$workingOnPromise = false;
        Vue.prototype.$dequeue();
      }
      return Promise.resolve();
    };

    Vue.prototype.$audio = [];
    Vue.prototype.$workingOnPromise = false;
    Vue.prototype.$say = function say(m) {
      const lang = store.getters.currentLocale;

      Vue.prototype.$audio.push({
        audio: new Audio(require(`@/assets/${lang}/${m}`)),
      });
      Vue.prototype.$dequeue();
      // Vue.prototype.$audio.currentTime = 0;
      // Vue.prototype.$audio.pause();
      // Vue.prototype.$audio = new Audio(require(`@/assets/${lang}/${m}`));
      // Vue.prototype.$audio.play();
    };
  },
};
